<template>
	<div class="page" v-loading="loadingPage">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
			<div></div>
		</div>
		<div class="page-main">
			<div class="padding bg-white shadow-warp">
				<el-form ref="formAdd" :model="formAdd" label-width="180px" label-suffix=":" :rules="rulesAdd" :validate-on-rule-change="false">
					<el-form-item label="主体状态" prop="subject_state">
						<el-radio-group v-model="formAdd.subject_state" @change="changeSubjectState">
							<el-radio-button :label="1">已注册</el-radio-button>
							<el-radio-button :label="0">未注册</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="主体类型" prop="subject_type">
						<el-radio-group v-model="formAdd.subject_type">
							<el-radio-button :label="1">公司</el-radio-button>
							<el-radio-button :label="2">个体</el-radio-button>
							<el-radio-button :label="0">其他</el-radio-button>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="名称" prop="name">
						<el-input
							v-model="formAdd.name"
							:disabled="formAdd.subject_state == 0"
							placeholder="客户名称,一般是企业名称"
							autocomplete="off"
							style="width: 300px;"
						></el-input>
					</el-form-item>
					<el-form-item label="统一社会信用代码" prop="credit_code">
						<el-input
							v-model="formAdd.credit_code"
							:disabled="formAdd.subject_state == 0"
							placeholder="统一社会信用代码"
							autocomplete="off"
							style="width: 300px;"
						></el-input>
					</el-form-item>
					<el-form-item label="联系人" prop="contacter" :rules="{ required: true, message: '请创建联系人', trigger: 'blur' }">
						<div
							class="padding-tb-sm padding-lr border radius"
							style="line-height: 22px; display: inline-block; min-width: 120px; position: relative;"
							v-if="formAdd.contacter"
						>
							<div class="flex align-center" @click="dialogVisibleAddContacter=true">
								<span class="text-bold">{{ formAdd.contacter.name }}</span>
								<span class="cu-tag sm radius line-orange margin-left-xs" v-if="formAdd.contacter.position">{{ formAdd.contacter.position }}</span>
							</div>
							<div class="text-grey">{{ formAdd.contacter.mobile }}</div>
							<div class="cu-tag round sm" style="position: absolute; top: -8px; right: -8px;" @click="formAdd.contacter = null"><i class="el-icon-close"></i></div>
						</div>
						<el-button size="medium" @click="contacterAddShow = true" v-else>
							<i class="el-icon-plus"></i>
							创建
						</el-button>
					</el-form-item>
					<el-form-item label="行业" prop="industry" :rules="{ required: true, message: '请选择所属行业', trigger: 'blur' }">
						<select-industry :selected="formAdd.industry" :clearable="true" :multiple="true" @change="changeIndustry"></select-industry>
						<i class="margin-left-xs text-grey el-icon-info"></i>
						<span class="text-grey">可多选</span>
					</el-form-item>
					<el-form-item label="固定电话" prop="telephone">
						<el-input v-model="formAdd.telephone" placeholder="固定电话" autocomplete="off" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="传真" prop="fax"><el-input v-model="formAdd.fax" placeholder="传真" autocomplete="off" style="width: 220px;"></el-input></el-form-item>
					<el-form-item label="所属地区" prop="region" :rules="{ required: true, message: '请选择所属省市县(区)', trigger: 'blur' }">
						<cascader-region :value="formAdd.region" :deep="3" autoLoad @change="changeRegion"></cascader-region>
					</el-form-item>
					<el-form-item label="地址" prop="address" :rules="{ required: true, message: '请输入地址', trigger: 'blur' }">
						<el-input v-model="formAdd.address" placeholder="详细地址" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="备注信息" v-model="formAdd.remark"></el-input>
					</el-form-item>
					<el-form-item label="业务人员" prop="salesman_id">
						<el-tag
							size="small"
							type="info"
							disable-transitions
							:closable="salesman ? true : false"
							@close="clearEmployee('salesman')"
							@click="check_employee_show('salesman')"
							v-if="salesman"
						>
							<span>{{ salesman.name }}({{ salesman.officeid }})</span>
						</el-tag>
						<el-button size="medium" @click="check_employee_show('salesman')" v-else>
							点击选择
							<i class="el-icon-arrow-down"></i>
						</el-button>
					</el-form-item>
					<el-form-item label="客服人员" prop="service_id">
						<el-tag
							size="small"
							type="info"
							disable-transitions
							:closable="service ? true : false"
							@close="clearEmployee('service')"
							@click="check_employee_show('service')"
							v-if="service"
						>
							<span>{{ service.name }}({{ service.officeid }})</span>
						</el-tag>
						<el-button size="medium" @click="check_employee_show('service')" v-else>
							点击选择
							<i class="el-icon-arrow-down"></i>
						</el-button>
					</el-form-item>
					<el-form-item label="" class="border-top padding-top">
						<el-button type="primary" @click="formSubmit()">
							<span class="el-icon-upload"></span>
							提交保存
						</el-button>
					</el-form-item>
				</el-form>
			</div>
			<check-employee :show="checkEmployeeShow" :dKey="checkEmployeeKey" @close="checkEmployeeClose" @change="changeEmployee" type="single"></check-employee>
		</div>
		<el-dialog
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			append-to-body
			:visible.sync="dialogVisibleAddContacter"
			width="500px"
			:show-close="false"
			top="10vh"
		>
			<div slot="title" class="flex align-center justify-between">
				<div class="flex align-center">
					<span class="el-icon-connection text-gray text-xxl"></span>
					<div class="margin-left-xs"><div class="text-bold">添加联系人到客户</div></div>
				</div>
				<el-link :underline="false" type="info" @click="dialogVisibleAddContacter = false"><i class="el-icon-close text-xxl"></i></el-link>
			</div>
			<div class="padding">
				<el-form ref="formAddContacter" :model="formAddContacter" label-width="60px" label-suffix=":">
					<el-form-item label="姓名" prop="name">
						<span class="text-bold">{{ formAddContacter.name }}</span>
					</el-form-item>
					<el-form-item label="性别" prop="gender">
						<span class="cu-tag line-blue radius" v-if="formAddContacter.gender == 1">先生</span>
						<span class="cu-tag line-pink radius" v-else-if="formAddContacter.gender == 2">女士</span>
						<span class="cu-tag line-grey radius" v-else>未知</span>
					</el-form-item>
					<el-form-item label="手机" prop="mobile">
						<span class="text-bold text-blue">{{ formAddContacter.mobile }}</span>
					</el-form-item>
					<el-form-item label="职务" prop="position">
						<el-input v-model="formAddContacter.position" placeholder="在该企业内职务" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="身份" prop="status">
						<el-checkbox-group v-model="formAddContacter.status">
							<el-checkbox label="法人"></el-checkbox>
							<el-checkbox label="股东"></el-checkbox>
							<el-checkbox label="高管"></el-checkbox>
							<el-checkbox label="财务"></el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="备注信息" v-model="formAddContacter.remark"></el-input>
					</el-form-item>
				</el-form>
				<div class="border-top padding-top-lg text-right">
					<el-button @click="dialogVisibleAddContacter = false">取 消</el-button>
					<el-button type="primary" @click="formSubmitAddContacter">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		<contacter-add :show="contacterAddShow" @close="contacterAddShow = false" @change="addContacter"></contacter-add>
	</div>
</template>

<script>
import checkEmployee from '@/components/check-employee.vue';
import selectIndustry from '@/components/select-industry.vue';
import cascaderRegion from '@/components/cascader-region.vue';
import contacterAdd from '@/components/contacter-add.vue';
export default {
	components: { checkEmployee, selectIndustry, cascaderRegion, contacterAdd },
	data() {
		return {
			loadingPage: false,
			rulesAdd: {
				name: { required: true, message: '请输入客户名称', trigger: 'blur' },
				credit_code: { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
			},
			checkEmployeeShow: false,
			checkEmployeeCurrent: [],
			checkEmployeeKey: null,
			checkEmployeeType: 'single',
			salesman: null,
			service: null,
			formAdd: {
				subject_state: 1,
				subject_type: 1,
				industry: [],
				region: ['610000', '610100', '610113']
			},
			contacterAddShow: false,
			dialogVisibleAddContacter: false,
			formAddContacter: {
				status: []
			}
		};
	},
	beforecreate: function() {},
	created: function() {
		this.initAdd();
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		initAdd() {
			this.formAdd = Object.assign(
				{},
				{
					subject_state: 1,
					subject_type: 1,
					contacter: null,
					industry: [],
					region: ['610000', '610100', '610113']
				}
			);
			this.salesman = null;
			this.service = null;
		},
		changeSubjectState(val) {
			if (val === 1) {
				this.rulesAdd = {
					name: { required: true, message: '请输入客户名称', trigger: 'blur' },
					credit_code: { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
				};
			} else {
				this.rulesAdd = {};
			}
		},
		check_employee_show(key) {
			this.checkEmployeeShow = true;
			this.checkEmployeeKey = key;
		},
		checkEmployeeClose() {
			this.checkEmployeeShow = false;
		},
		changeEmployee(e) {
			this[e.key] = e.data;
		},
		clearEmployee(key) {
			this[key] = null;
		},
		changeIndustry(e) {
			this.formAdd.industry = e;
		},
		changeRegion(e) {
			this.formAdd.region = e;
		},
		addContacter(val) {
			this.formAddContacter = Object.assign(
				{
					status: []
				},
				val
			);
			this.dialogVisibleAddContacter = true;
		},
		formSubmitAddContacter() {
			this.formAdd.contacter = Object.assign({}, this.formAddContacter);
			this.dialogVisibleAddContacter = false;
		},
		formSubmit() {
			this.$refs['formAdd'].validate(valid => {
				if (valid) {
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=crm/customer&a=add', this.formAdd).then(
						res => {
							loading.close();
							if (res.result == 'ok') {
								this.$alert('创建客户信息成功！', {
									title: '操作成功',
									type: 'success',
									showCancelButton: true,
									confirmButtonText: '继续添加',
									cancelButtonText: '查看信息',
									callback: r => {
										if (r == 'confirm') {
											this.initAdd();
										} else {
											this.$router.push('/crm/customer/view/' + res.data.id);
										}
									}
								});
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
					return false;
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	}
};
</script>

<style>
.infoshow .title {
	min-width: 180px;
}
</style>
